module.exports = "mutation userPasswordUpdate($user:UserPasswordUpdateInput!){userPasswordUpdate(user:$user)}"